import { type ButtonHTMLAttributes, forwardRef } from 'react'

export interface ButtonProps extends ButtonHTMLAttributes<HTMLDivElement> {
  variant?: 'primary' | 'secondary' | 'ghost' | 'white' | 'custom'
  size?: 'sm' | 'md' | 'lg'
}

export const Button = forwardRef<HTMLDivElement, ButtonProps>(
  ({ variant = 'primary', size = 'md', className = '', children, disabled, onClick, ...props }, ref) => {

    const variantClasses = {
      // 主色白字
      primary: 'bg-linear-to-br from-indigo-500 to-purple-600 text-white shadow-md hover:opacity-90 active:opacity-70',
      // 3. 灰底白字（低对比度次要）
      secondary: 'bg-white/10 text-white hover:bg-white/20',
      // 4. 纯文本感（Hover显色）
      ghost: 'bg-transparent text-white/60 hover:bg-white/10 hover:text-white',
      // 白底黑字
      white: "bg-white text-black border border-black hover:bg-blue-300 active:bg-blue-400",
      custom: ''
    }

    const sizeClasses = {
      sm: 'text-xs py-2 px-3',
      md: 'text-sm py-2.5 px-4',
      lg: 'text-base py-3 px-5'
    }

    const disabledClasses = disabled ? 'bg-white/10 text-white/30 cursor-not-allowed shadow-none' : ''

    return (
      <div
        ref={ref}
        className={`justify-center items-center text-center font-medium rounded-lg transition-all cursor-pointer border-none
           ${variantClasses[variant]} ${sizeClasses[size]} ${disabledClasses} ${className} `}
        // disabled={disabled}
        onClick={disabled ? () => { } : onClick}
        {...props}
      >
        {children}
      </div>
    )
  }
)

Button.displayName = 'Button'
